import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { InputComponent } from '../../shared/input/input.component';
import { LoginAdminUser } from '../../../models/adminmanagement/AdminUser';
import { AlertService } from '../../../services/shared/alert.service';
import { ErrorHandlerService } from '../../../services/shared/error-handler.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AdminManagementService } from '../../../services/adminmanagement/adminmanagement.service';
import { ConstantValues } from '../../../common/constant-values';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent implements OnInit {
  loginAdminUser = new LoginAdminUser();
  isLoading = false;
  isPasswordVisible: boolean = false;

  @ViewChildren(InputComponent) inputComponents!: QueryList<InputComponent>;

  constructor(private router: Router, private adminService: AdminManagementService,
    private alertService: AlertService, private errorHandler: ErrorHandlerService) { }

    ngOnInit(): void {
      const langKey = ConstantValues.StaticValue.PMS_SYTSTEM_LANG;
      const lang = localStorage.getItem(langKey);
      
      localStorage.clear();
      
      if (lang) {
        localStorage.setItem(langKey, lang);
      }
    }

  
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
    }
    
  login(event: { page: string, form?: NgForm }) {
    if (event.form?.valid) {
      this.isLoading = true;
      this.adminService.loginAdminUser(this.loginAdminUser).subscribe(res => {
        this.isLoading = false;
        if (res.Result && res.Result.TwoFactorRequired == "True") {
          localStorage.setItem(ConstantValues.PhoneNumber, res.Result.PhoneNumber);
          localStorage.setItem(ConstantValues.LoginUserEmail, this.loginAdminUser.Email);
          this.router.navigate(['otp']);
        }else if (res.Result && res.StatusCode === '000' && res.Result.TwoFactorRequired == "False") {
          localStorage.setItem(ConstantValues.PhoneNumber, res.Result.PhoneNumber);
          localStorage.setItem(ConstantValues.TokenKey, res.Result.AccessToken);
          localStorage.setItem(ConstantValues.RefreshTokenKey, res.Result.RefreshToken)
          this.router.navigate(['dashboard']);
        }else if (res.Result && res.StatusCode === ConstantValues.HASH_MISMATCH_ERROR) {
            this.alertService.HashMismatchError();
        } else{
          this.alertService.Error(res.Message).then(result => {
            // if (result.isConfirmed)
            //   this.login(event);
          });

        }
      }, (err: HttpErrorResponse) => {
        this.isLoading = false;
        if (err.status != 401) {
          this.alertService.showError(this.errorHandler.handleError(err)).then(result => {
            if (result.isConfirmed)
              this.login(event);
          });
        } else {
          this.alertService.Error('Your session has expired. Please log in again.')
            .then(() => { this.router.navigate(['/login']); });
        }
      })
    } else {
      this.markAllInputsAsTouched();
    }
  }

  markAllInputsAsTouched(): void {
    this.inputComponents.forEach((input) => {
      input.markAsTouched();
    });
  }
}
